import React from 'react';
import {animated} from '@react-spring/web';
import Markdown from 'markdown-to-jsx';
import {useSpotlightTransitions} from '@dazn/lp-web/src/hooks/useTransitions';
import {
    IFeature,
    IFreemiumBanner
} from '@dazn/lp-web/src/types/freemiumBanner.types';
import styles from '@dazn/lp-web/src/components/FreemiumBanner/freemium-banner.module.css';
import {elementClickEventTypes} from '@dazn/lp-web/src/analytics/fe-events/elementClick';
import {triggerElementClick} from '@dazn/lp-web/src/analytics/fe-events';
import StaticImage from '@dazn/lp-web/src/components/Images/ImageComponent/Image';
import {ComponentTypes} from '@dazn/lp-web/src/constants/componentTypes.constants';
import classNames from 'classnames';
import isQueryParamTrue from '../../utils/isQueryparamTrue';

interface IProps {
    data: IFreemiumBanner;
    key: number;
    disableAnimation: boolean;
    componentPosition: number;
}
const FreemiumBanner: React.FC<IProps> = ({
    data,
    disableAnimation,
    componentPosition
}) => {
    const {banner} = data;
    const [refView, springs] = useSpotlightTransitions();

    const animations = disableAnimation
        ? {}
        : {
              style: springs,
              ref: refView
          };

    const handleButtonClick = () => {
        triggerElementClick({
            section: elementClickEventTypes.BODY,
            itemId: 'welcome_register_for_free',
            resourceString: banner.button.label || ''
        });

        if (banner?.button?.action) {
            banner?.button?.action();
        }
    };

    return (
        <div
            className={classNames(styles.backgroundSection, {
                [styles.marginTopZero]: componentPosition === 0
            })}
        >
            <StaticImage
                image={banner?.image}
                alt="Freemium Background Image"
                componentType={ComponentTypes.FREEMIUM_BANNER}
                showPlaceHolderImage
            />
            <animated.div {...animations} className={styles.overlayContainer}>
                <Markdown className={styles.title}>{banner?.title}</Markdown>
                <Markdown className={styles.description}>
                    {banner?.description}
                </Markdown>
                {banner?.button?.label && (
                    <div
                        className={styles.bannerActions}
                        data-target="banner-actions"
                    >
                        {isQueryParamTrue('seo') ? (
                            <a
                                href={banner?.button?.navigationLink}
                                className={classNames(
                                    'seoButton',
                                    styles.feemiumSeoBtn
                                )}
                            >
                                {banner.button.label}
                            </a>
                        ) : (
                            <button onClick={handleButtonClick}>
                                {banner.button.label}
                            </button>
                        )}
                    </div>
                )}
                {banner?.features?.length > 0 ? (
                    <div className={styles.features}>
                        {banner?.features.map(
                            (feature: IFeature, i: number) => (
                                <li key={`feature-${i}`}>
                                    <img
                                        src={feature?.iconUrl}
                                        alt="icon"
                                        height={'14px'}
                                        width={'14px'}
                                    />
                                    <span>{feature?.value}</span>
                                </li>
                            )
                        )}
                    </div>
                ) : null}
            </animated.div>
        </div>
    );
};

export default FreemiumBanner;
